// extracted by mini-css-extract-plugin
export default {"salePointGroup":"SalePoint_salePointGroup__wuOZ2","item":"SalePoint_item__ADxxs","heading":"SalePoint_heading__CD9dU","txt":"SalePoint_txt__JHuVo"};